<script>
  let username = $state(null);

  async function resetUser() {
    const r = await window.api.admin.resetUser.mutate({ username });
    console.log(r)
  }
</script>

<div class="container-xl">
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">User Reset</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <!-- svelte-ignore a11y_label_has_associated_control -->
            <label class="form-label required">Username</label>
            <div>
              <input type="text" class="form-control" placeholder="jjansen" bind:value={username} />
            </div>
          </div>
        </div>

        <div class="card-footer text-end">
          <button type="submit" class="btn btn-primary" onclick={resetUser}
            >Reset</button
          >
        </div>
      </div>
    </div>
  </div>
</div>
